/*eslint-disable*/
import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Chip,
  Divider,
  Button,
  Avatar,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import BookIcon from "@material-ui/icons/Book";
import HistoryIcon from "@material-ui/icons/History";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  page: { padding: theme.spacing(4) },
  card: {
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.shadows[3],
    maxWidth: 1100,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  chip: { fontWeight: 600 },
  stepRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.2),
  },
  avatar: { width: 44, height: 44, fontWeight: 700 },
  stepTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionBtn: { textTransform: "none", minWidth: 84 },
  featureCard: {
    height: "100%",
    borderRadius: 12,
    boxShadow: theme.shadows[2],
  },
  featureIcon: {
    fontSize: 28,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
}));

function Step({ index, title, desc, to }) {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div className={classes.stepRow}>
      <Avatar style={{ backgroundColor: "#059669" }} className={classes.avatar}>
        {index}
      </Avatar>

      <div style={{ flex: 1 }}>
        <div className={classes.stepTitleRow}>
          <Typography variant="subtitle1">{title}</Typography>
          {to ? (
            <Button
              size="small"
              variant="outlined"
              className={classes.actionBtn}
              onClick={() => navigate(to)}
            >
              Open
            </Button>
          ) : null}
        </div>
        <Typography variant="body2" color="textSecondary">
          {desc}
        </Typography>
      </div>
    </div>
  );
}

export default function UserJourneyNurse() {
  const classes = useStyles();

  const steps = [
    {
      title: "View & Edit Profile",
      desc: "View and edit your nurse profile and contact information.",
      to: "/nurseprofile",
    },
    {
      title: "Edit Profile",
      desc: "Update your profile details and settings.",
      to: "/nurseeditprofile",
    },
    {
      title: "Calendar & Appointments",
      desc: "View your calendar and manage nurse-specific appointments.",
      to: "/nursecalendar",
    },
    {
      title: "Clinic Bookings",
      desc: "Manage clinic bookings and patient flow.",
      to: "/nurseclinicbooking",
    },
    {
      title: "Treatment Notes",
      desc: "Access and update patient treatment notes.",
      to: "/nursetreatmentnotes",
    },
    {
      title: "Booking History",
      desc: "View past nurse bookings and booking history.",
      to: "/nursebookingshistory",
    },
    {
      title: "Timeline",
      desc: "View your activity timeline.",
      to: "/nursetimeline",
    },
  ];

  const capabilities = [
    {
      icon: <PersonIcon className={classes.featureIcon} />,
      title: "Edit Profile",
      desc: "Update contact details and professional information.",
    },
    {
      icon: <CalendarTodayIcon className={classes.featureIcon} />,
      title: "Manage Nurse Calendar",
      desc: "Create and manage nurse appointments and shifts.",
    },
    {
      icon: <BookIcon className={classes.featureIcon} />,
      title: "Clinic Bookings",
      desc: "View and update clinic bookings and patient allocations.",
    },
    {
      icon: <HistoryIcon className={classes.featureIcon} />,
      title: "Treatment Notes",
      desc: "Add and edit treatment notes for patients.",
    },
  ];

  return (
    <div className={classes.page}>
      <Paper className={classes.card}>
        <div className={classes.header}>
          <div>
            <Typography variant="h5" gutterBottom>
              <PersonIcon style={{ verticalAlign: "middle", marginRight: 8 }} />
              Nurse — Help & Quick Actions
            </Typography>
            <Typography variant="body2" color="textSecondary">
              (Nurse) Tools for clinic and patient support
            </Typography>
          </div>
          <Chip
            label="Nurse"
            className={classes.chip}
            style={{ backgroundColor: "#FFF7ED" }}
          />
        </div>

        {/* Journey Steps */}
        <div>
          {steps.map((s, i) => (
            <Step key={s.title} index={i + 1} title={s.title} desc={s.desc} to={s.to} />
          ))}
        </div>

        <Divider style={{ margin: "20px 0" }} />

        {/* Nurse Capabilities */}
        <Typography variant="h6" gutterBottom>
          Key Nurse Capabilities
        </Typography>
        <Grid container spacing={3}>
          {capabilities.map((f) => (
            <Grid item xs={12} sm={6} md={4} key={f.title}>
              <Card className={classes.featureCard}>
                <CardContent>
                  {f.icon}
                  <Typography variant="subtitle1" gutterBottom>
                    {f.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {f.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </div>
  );
}

